import { Link, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { formatUTCDateWithLocalTime } from "../../../utils";
import useCompanyTypeList from "../../phonebook/hooks/useCompanyTypeList";
import { CompanyType } from "./types";

export const companyColumns = (companyTypeList: CompanyType[]): MRT_ColumnDef<any>[] => [
  {
    accessorKey: "createdDate",
    header: "Created Date",
    size: 50,
    accessorFn: (row) => (row.history ? formatUTCDateWithLocalTime(row.history[0]?.date) : null),
    Cell: ({ renderedCellValue, row }) => <Typography>{formatUTCDateWithLocalTime(row.original.history[0]?.date)}</Typography>,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "createdByUser",
    header: "Created By",
    size: 50,
    Cell: ({ renderedCellValue, row }) => <Typography>{row.original.history[0]?.username}</Typography>,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "name",
    header: "Name",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    Cell: ({ renderedCellValue, row }) => (
      <Link href={`/phonebook/company/profile?id=${row.original.id}`} target="_blank">
        <Typography variant="body2">{row.original.name} </Typography>
      </Link>
    ),
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorFn: (row) => {
      const selectedCompanyType =
        companyTypeList.find((t) => t.id === row.companyTypeId) || ({ name: "" } as CompanyType);
      return selectedCompanyType.name;
    },
    id: "companyTypeName", 
    header: "Type",
    size: 50,
    Cell: ({ cell }) => (
      <Typography>{String(cell.getValue() ?? "")}</Typography>
    ),
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "website",
    header: "Website",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorFn: (row) =>
      `${row.branches?.[0]?.address1 ?? ""} ${row.branches?.[0]?.city ?? ""} ${row.branches?.[0]?.state ?? ""} ${row.branches?.[0]?.zip ?? ""}`,
    id: "address", 
    header: "Address",
    size: 50,
    Cell: ({ cell }) => (
      <Typography>
        {String(cell.getValue() ?? "")}
      </Typography>
    ),
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  }
];
